// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconClock: React.FC = () => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13"><path fill="currentColor" d="M6,0 C2.68593764,0 0,2.68593764 0,6 C0,9.31406236 2.68593764,12 6,12 C9.31406236,12 12,9.31406236 12,6 C12,2.68593764 9.31406236,0 6,0 Z M8.59687471,7.5 C8.49285936,7.68053913 8.30343747,7.78125 8.109375,7.78125 C8.01379681,7.78125 7.91711712,7.7570858 7.82859349,7.70580482 L5.71875,6.48749971 C5.54531264,6.38671875 5.4375,6.20156264 5.4375,6 L5.4375,2.8125 C5.4375,2.50312471 5.69062507,2.25 6,2.25 C6.30937529,2.25 6.5625,2.50195312 6.5625,2.8125 L6.5625,5.67421889 L8.39203119,6.73078108 C8.66015625,6.88593721 8.75390625,7.23046875 8.59687471,7.5 Z" transform="translate(0 .5)"/></svg>);
};

export default React.memo(IconClock);
